export enum Fit {
  METACOGNITION = 'METACOGNITION',
  DIVERSION = 'DIVERSION',
  PLANNING = 'PLANNING',
  SPATIAL_PERCEPTION = 'SPATIAL_PERCEPTION',
  SELF_AFFIRMATION = 'SELF_AFFIRMATION',
  OPPORTUNITY_POSITIVE = 'OPPORTUNITY_POSITIVE',
  PURSUIT_OF_RECOGNITION = 'PURSUIT_OF_RECOGNITION',
  PURSUIT_OF_GROWTH = 'PURSUIT_OF_GROWTH',
  CHECK_BEHAVIOR = 'CHECK_BEHAVIOR',
  CONTROL_BEHAVIOR = 'CONTROL_BEHAVIOR',
  UNDERSTAND_THE_CONTEXT = 'UNDERSTAND_THE_CONTEXT',
  RELATIONAL_RESPONSE = 'RELATIONAL_RESPONSE',
  ACTIVE = 'ACTIVE',
  EMPATHY = 'EMPATHY',
  COOPERATION = 'COOPERATION',
  ACCOUNTABILITY = 'ACCOUNTABILITY',
}

export const fitTextMap: Record<FitType, string> = {
  METACOGNITION: '메타인지',
  DIVERSION: '주의전환',
  PLANNING: '계획능력',
  SPATIAL_PERCEPTION: '공간지각',
  SELF_AFFIRMATION: '자기긍정',
  OPPORTUNITY_POSITIVE: '기회긍정',
  PURSUIT_OF_RECOGNITION: '인정추구',
  PURSUIT_OF_GROWTH: '성장추구',
  CHECK_BEHAVIOR: '점검행동',
  CONTROL_BEHAVIOR: '조절행동',
  UNDERSTAND_THE_CONTEXT: '맥락이해',
  RELATIONAL_RESPONSE: '관계대응',
  ACTIVE: '능동성',
  EMPATHY: '공감성',
  COOPERATION: '협력성',
  ACCOUNTABILITY: '책임성',
};

export const fitDescTextMap: Record<FitType, string> = {
  METACOGNITION: '자신의 행동에 대해서 객관적으로 잘 파악하는 능력을 의미합니다.',
  DIVERSION: '서로 다른 종류의 일을 전환하여 효율적으로 일을 처리하는 능력을 의미합니다.',
  PLANNING: '목표 달성을 위해 여러 변수를 상상하고 추측하여 계획을 수립하는 능력을 의미합니다.',
  SPATIAL_PERCEPTION: '공간에 대한 정보를 기억해내는 능력을 의미합니다.',
  SELF_AFFIRMATION: '스스로 원하는 수준의 성과를 거둘 수 있다고 믿는 태도를 의미합니다.',
  OPPORTUNITY_POSITIVE: '새로운 기회에 빠르게 반응하고 적극적으로 보상을 얻고자 하는 태도를 의미합니다.',
  PURSUIT_OF_RECOGNITION: '사회적인 칭찬이나 인정을 추구하는 정도를 의미합니다.',
  PURSUIT_OF_GROWTH: '내면의 성장과 만족감을 추구하는 정도를 의미합니다.',
  CHECK_BEHAVIOR: '자신의 행동이 목적에 부합하는지 끊임없이 점검하는 태도를 의미합니다.',
  CONTROL_BEHAVIOR: '상황에 맞게 자신의 행동이나 감정을 유연하게 조절하는 태도를 의미합니다.',
  UNDERSTAND_THE_CONTEXT: '감정, 정서, 기분 뿐만이 아닌 의도와 상황의 흐름 등을 이해하는 능력을 의미합니다.',
  RELATIONAL_RESPONSE: '목표 달성을 위해 상황에 맞게 상대방에게 표현하는 능력을 의미합니다.',
  ACTIVE: '주도적, 접근적, 자발적인 태도를 의미합니다.',
  EMPATHY: '타인의 관점에서 생각하고 그 사람의 감정을 느끼고 이해하는 능력을 의미합니다.',
  COOPERATION: '집단 중심적, 공동체 중심적인 사고와 남을 도와주려는 성향을 의미합니다.',
  ACCOUNTABILITY: '나에게 주어진 것을 끝까지 맡아서 해내고자 하는 태도를 의미합니다.',
};

export type FitType = keyof typeof Fit;
